"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sizes = _interopRequireDefault(require("./sizes"));
var _platform = require("../../helpers/platform");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var sizeAdapter = function sizeAdapter(value) {
  if (String(value).indexOf('px') !== -1) {
    return value;
  }
  return "".concat(value, "px");
};
var numberParser = function numberParser(property) {
  return parseInt(_sizes["default"][property], 0);
};
var util = {
  sizeAdapter: sizeAdapter,
  numberParser: numberParser,
  isMsite: _platform.isMsite
};
var _default = exports["default"] = util;